import styled from 'styled-components';
import {device} from '@guestapp/ui/src/utils/device';

export const HeaderWrapper = styled.div<{visible?: boolean}>`
  width: 100%;
  z-index: 5;
  display: ${props => (props.visible ? 'block' : 'none')};
  position: ${props => (props.visible ? 'sticky' : 'initial')};
  top: 0;
  height: 64px;
  background: #ffffff;
  border-bottom: 1px solid rgba(21, 41, 70, 0.2);

  @media (min-width: ${device.tablet}) {
    display: block;
    margin-bottom: 20px;
  }
`;

export const Container = styled.div`
  margin: auto;
  display: flex;
  width: 100%;
  align-items: center;
  height: 100%;
  padding: 0 15px;
  background-color: #fff;
  @media (min-width: ${device.tablet}) {
    background-color: rgb(244, 246, 249);
    padding: 0 64px;
  }
`;

export const HeaderTitle = styled.div`
  cursor: pointer;
  font-weight: 700;
  font-size: 24px;

  @media (max-width: ${device.tabletSubHeader}) {
    font-size: 16px;
    width: 100%;
  }
`;

export const LogoContainer = styled.div`
  display: flex;

  & img {
    margin-right: 16px;
    width: 35px;
    height: 35px;

    border-radius: 50%;
  }

  @media (min-width: ${device.tablet}) {
    display: none;
  }
`;

export const Title = styled.div`
  width: 200px;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  @media (min-width: ${device.tablet}) {
    width: 100%;
  }
`;
